var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href)?_c('a',{staticClass:"cta",class:[{ small: _vm.small }, _vm.color],attrs:{"target":_vm.target,"href":_vm.href}},[_vm._v(_vm._s(_vm.label))]):_c('router-link',{staticClass:"cta",class:[{ small: _vm.small }, _vm.color],attrs:{"to":_vm.to,"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }